module.exports = __webpack_public_path__ + "img/title3.0e6a8dfc.png";